module.exports = __webpack_public_path__ + "img/cases-part-axiaoke1.0e13a5e4.png";